import createComponent, {
  ElementWithProps
} from '@carvana/merch-components/createComponent';
import cx from 'classnames';
import Link from 'next/link';

export const BlueFillerBackground = createComponent('div', {
  className: `
    col-span-full row-span-full self-start h-[100px]
    bg-background-primary
  `
});

export const ContentContainer = createComponent('div', {
  className: `
    z-1 col-span-full row-span-full flex flex-col items-center justify-between p-2xl sm:pt-4xl
  `
});

export const StyledLink = createComponent(Link, {
  className: `
    @container grid min-h-[352px] sm:min-h-[388px] h-full grid-cols-1 overflow-hidden rounded-md
    bg-background-muted-subtle bg-no-repeat shadow-sm
    hover:shadow-md
  `
});

export const TileCta = createComponent<ElementWithProps<{ inverse?: boolean }>>(
  'span',
  ({ inverse }) => ({
    className: cx(
      'mx-auto flex w-full items-center justify-center rounded-round px-2xl py-[10px] t-label-sm whitespace-nowrap',
      inverse
        ? 'bg-background-default text-text-primary hover:bg-background-default-hover hover:text-text-primary-hover'
        : 'bg-background-primary text-text-inverse hover:bg-background-primary-hover'
    )
  })
);
